import { ActionTree } from "vuex";
import { State } from "./state";
import { IStudentCategory } from "@/interfaces/IStudentCategory";
import { Vue } from "vue-property-decorator";
import i18n from "@/i18n";

import axios from "@/utils/axios";

import { SET_DATA_ITEM, SET_DATA_LIST, IS_LOADING, SET_SUCCESS, SET_ERROR, SET_FILTERED_STUDENT_CATEGORIES } from "@/store/StudentCategories/types";

const URL = "/student-categories";

export const findAllCategories = async (store: any): Promise<any> => {
  store.commit("IS_LOADING", true);

  return await axios
    .get(URL + "/")
    .then(({ data }) => {
      store.commit(SET_DATA_LIST, data);
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ error }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(SET_ERROR, error);
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export const filterStudentCategories = async (store: any, filter: any): Promise<any> => {
  store.commit("IS_LOADING", true);

  return await axios
    .post(URL + "/filter", filter)
    .then(({ data }) => {
      store.commit(SET_FILTERED_STUDENT_CATEGORIES, data);
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ error }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(SET_ERROR, error);
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export const createCategory = async (store: any, category: IStudentCategory): Promise<any> => {
  store.commit("IS_LOADING", true);

  return await axios
    .post(URL, category)
    .then(({ data }) => {
      store.commit(SET_SUCCESS, true);
      Vue.toasted.success(String(i18n.t("messages.operation_successful")));
      return data || true;
    })
    .catch(({ error }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(SET_ERROR, error);
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export const updateCategory = async (store: any, category: IStudentCategory): Promise<any> => {
  store.commit("IS_LOADING", true);

  return await axios
    .put(`${URL}/${category.id}`, category)
    .then(({ data }) => {
      store.commit(SET_SUCCESS, true);
      Vue.toasted.success(String(i18n.t("messages.operation_successful")));
      return data || true;
    })
    .catch(({ error }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(SET_ERROR, error);
      Vue.toasted.error(String(i18n.t("messages.operation_error")));
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export const getCategoryById = async (store: any, id: any): Promise<any> => {
  store.commit("IS_LOADING", true);

  return await axios
    .get(`${URL}/${id}`)
    .then(({ data }) => {
      store.commit(SET_DATA_ITEM, data);
      store.commit(SET_SUCCESS, true);
    })
    .catch(({ error }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(SET_ERROR, error);
    })
    .finally(() => store.commit(IS_LOADING, false));
};

export const archiveStudentCategory = async (store: any, options: any): Promise<void> => {
  store.commit(IS_LOADING, true);
  return await axios
    .post(`${URL}/archive?id=${options.id}&archived=${options.archived}`)
    .then(({ data }) => {
      store.commit(SET_SUCCESS, true);
      store.commit(IS_LOADING, false);
      store.commit(SET_DATA_ITEM, data);
    })
    .catch(({ response }) => {
      store.commit(SET_SUCCESS, false);
      store.commit(IS_LOADING, false);
      store.commit(SET_ERROR, response.data);
    });
};

export default <ActionTree<State, any>>{
  findAllCategories,
  filterStudentCategories,
  getCategoryById,
  createCategory,
  updateCategory,
  archiveStudentCategory,
};
